export const searchBoxCatIdDev = `feats-search-box`